import axios from "axios";
import { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { getRisk } from "./getRisk";
import { Toast } from "@ad/anq-ui";

export const UNAVAILABLE_CODE = 5000001;

export const riskForbidden = [
  "/mms-gateway/user/getToken",
  "/mms-gateway/user/checkToken",
];

const fillUrl = (url: string) => {
  return !url.startsWith("/") && !url.startsWith("http") ? `/${url}` : url;
};

interface IRequestConfig extends AxiosRequestConfig {
  returnRawData?: boolean;
  notErrorToast?: boolean;
}

const instance = axios.create({
  timeout: 10000,
});

export const getDirectUrl = () => {
  const url = `https:${
    process.env.DMP_URL
  }/clint/api/login?redirect=${encodeURI(
    location.href.replace(/^http:/, "https:")
  )}`;

  return `${process.env.MMS_URL}/login/?platform=dmp&redirectUrl=${encodeURI(
    url
  )}`;
};

instance.interceptors.request.use(
  async (config: IRequestConfig) => {
    const crawlerInfo = await getRisk();
    config.headers = {
      ...config.headers,
      "Anti-Content": crawlerInfo,
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res: AxiosResponse) => {
    const { data } = res;
    if (data.errorCode === 10 && window) {
      location.href = getDirectUrl();
    }
    if (
      (res.config as IRequestConfig).returnRawData ||
      data.error_code === UNAVAILABLE_CODE
    ) {
      return res.data;
    }
    if (data.success) {
      return data?.result || data?.data;
    }
    if (!data.success && !(res.config as IRequestConfig).notErrorToast) {
      Toast.error(
        data?.error_msg || data?.errorMsg || data?.message || "服务器内部错误"
      );
    }
    return Promise.reject(data);
  },
  (error: any) => {
    if (error instanceof Error) {
      const status = (error as AxiosError)?.response?.status;
      if (status === 403 || status === 500) {
        Toast.warn("网络异常，请稍后再试");
      } else {
        Toast.warn(error.message || "服务器内部错误");
      }
    } else {
      Toast.error(
        error?.errorMsg ||
          error?.message ||
          error?.error_msg ||
          "服务器内部错误"
      );
    }
    return Promise.reject(error);
  }
);

const request = async (
  url: string,
  options: {
    data?: any;
    method: "get" | "post";
    config?: IRequestConfig;
    responseType?: any;
  }
) => {
  const { method, config, data } = options;
  const requestConfig = config ? { ...config, url, method } : { url, method };
  if (data) {
    method === "get"
      ? (requestConfig.params = data)
      : (requestConfig.data = data);
  }
  return instance
    .request(requestConfig)
    .then((data: any) => {
      return Promise.resolve(transformNull(data));
    })
    .catch((error) => {
      console.log({ error });
      return Promise.reject(error);
    });
};

const post = async (
  url: string,
  data: any,
  options?: { responseType?: any; config?: IRequestConfig }
) => {
  return request(fillUrl(url), { data, method: "post", ...(options || {}) });
};

const get = async (
  url: string,
  options?: { responseType?: any; config?: IRequestConfig }
) => {
  return request(fillUrl(url), { method: "get", ...(options || {}) });
};

export const transformNull = (jsonObj: any) => {
  jsonObj &&
    Object.keys(jsonObj).forEach((key) => {
      if (Object.prototype.toString.call(jsonObj[key]) === "[object Null]") {
        jsonObj[key] = undefined;
      }
      if (
        ["[object Object]", "[object Array]"].includes(
          Object.prototype.toString.call(jsonObj[key])
        )
      ) {
        transformNull(jsonObj[key]);
      }
    });
  return jsonObj;
};

export { post, get };
